import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { BsDownload } from "react-icons/bs";
import { FaCheckCircle, FaPencilAlt } from "react-icons/fa";
import { MdOutlineAutoFixHigh } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";
import { DeleteConfirmation } from "./DeleteConfirmation";
import { SetAvailableConfirmation } from "./SetAvailableConfirmation";
import styles from "./Details.module.css";
import { EditCatalog } from "./EditCatalog";
import { useDetails } from "./useDetails";

export const CatalogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    catalog,
    getCatalogLoading,
    handleProductSelection,
    handleRemoveBg,
    selectedProducts,
    removeBgLoading,
    handleRemoveMultipleBg,
    handleSelectAllProducts,
    handleDeleteMultipleProducts,
    handleEditCatalog,
    handleSetMultipleActive,
  } = useDetails();

  const handleDownloadFailedProductsCsv = (failedProducts = []) => {
    if (!failedProducts.length) return;

    const rows = failedProducts.map((item) =>
      typeof item === "string"
        ? `"${item.replace(/"/g, '""')}"`
        : `"${String(item)}"`
    );
    const csvContent = "\uFEFF" + rows.join("\n");
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "failed-products.csv";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  const [showEditCatalogDialog, setShowEditCatalogDialog] = useState(false);
  const handleCancelEditCatalogDialog = () => {
    setShowEditCatalogDialog(false);
  };
  const handleConfirmEditCatalogDialog = async (data) => {
    await handleEditCatalog(data);
    setShowEditCatalogDialog(false);
  };
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const handleCancelDeleteConfirmation = () => {
    setShowDeleteConfirmation(false);
  };
  const handleConfirmDeleteConfirmation = async () => {
    await handleDeleteMultipleProducts(selectedProducts);
    setShowDeleteConfirmation(false);
  };
  const [showSetAvailableConfirmation, setShowSetAvailableConfirmation] =
    useState(false);
  const handleCancelSetAvailableConfirmation = () => {
    setShowSetAvailableConfirmation(false);
  };
  const handleConfirmSetAvailableConfirmation = async () => {
    await handleSetMultipleActive(selectedProducts);
    setShowSetAvailableConfirmation(false);
  };
  if (getCatalogLoading) {
    return <Spinner />;
  }
  return (
    <div className={styles.catalogcontainer}>
      <div className={styles.upper}>
        <Link to="/">
          <span className={styles.swag}>
            Website
            <span className={styles.greater}> &gt; </span>
          </span>
        </Link>
        <Link to="/catalogs">
          <span className={styles.swag}>
            Catalogues
            <span className={styles.greater}> &gt; </span>
          </span>
        </Link>
        <span className={styles.req}>Products Listing</span>
      </div>
      <div className={styles.heading}>Products Listing</div>
      <div className={styles.buttonContainer}>
        <button
          className={styles.button}
          onClick={() => navigate(`/catalogs/${id}/products/add`)}
        >
          <AiOutlinePlus /> Add Product
        </button>
        <button
          disabled={selectedProducts.length === 0}
          className={styles.redButton}
          onClick={() => setShowDeleteConfirmation(true)}
          style={{
            backgroundColor:
              selectedProducts.length === 0 ? "#e0e0e0" : undefined,
            color: selectedProducts.length === 0 ? "#888" : undefined,
            cursor: selectedProducts.length === 0 ? "not-allowed" : undefined,
          }}
        >
          <RiDeleteBin6Fill />
          Delete Products
        </button>
        <button
          disabled={selectedProducts.length === 0 || removeBgLoading.loading}
          className={styles.button}
          onClick={() => handleRemoveMultipleBg(selectedProducts)}
          style={{
            backgroundColor:
              selectedProducts.length === 0 || removeBgLoading.loading
                ? "#e0e0e0"
                : undefined,
            color:
              selectedProducts.length === 0 || removeBgLoading.loading
                ? "#888"
                : undefined,
            cursor:
              selectedProducts.length === 0 || removeBgLoading.loading
                ? "not-allowed"
                : undefined,
          }}
        >
          <MdOutlineAutoFixHigh />
          Remove Background
        </button>
        <button
          disabled={selectedProducts.length === 0}
          className={styles.button}
          onClick={() => setShowSetAvailableConfirmation(true)}
          style={{
            backgroundColor:
              selectedProducts.length === 0 ? "#e0e0e0" : undefined,
            color: selectedProducts.length === 0 ? "#888" : undefined,
            cursor: selectedProducts.length === 0 ? "not-allowed" : undefined,
          }}
        >
          <FaCheckCircle />
          Set Available
        </button>
        {catalog?.failedProducts?.length > 0 && (
          <button
            className={styles.button}
            onClick={() =>
              handleDownloadFailedProductsCsv(catalog?.failedProducts)
            }
          >
            <BsDownload />
            Download Unprocessed links{" "}
            <span
              style={{
                fontSize: "12px",
                height: "25px",
                width: "25px",
                borderRadius: "100%",
                backgroundColor: "#e53935",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2px",
              }}
            >
              {catalog?.failedProducts?.length}
            </span>
          </button>
        )}
      </div>
      <div className={styles.heading}>
        {catalog?.name}
        <FaPencilAlt
          size={22}
          style={{ marginLeft: 10, cursor: "pointer" }}
          onClick={() => setShowEditCatalogDialog(true)}
        />
      </div>
      <div className={styles.subTextContainer}>
        <span className={styles.subText}>{catalog?.brand}</span>
        <span className={styles.subText}>|</span>
        <span className={styles.subText}>{catalog?.category?.name}</span>
       
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 10,
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <input
          type="checkbox"
          style={{ alignSelf: "center", marginRight: 8 }}
          checked={selectedProducts.length === catalog?.products?.length}
          onChange={handleSelectAllProducts}
        />
        <div style={{ fontSize: "16px", fontWeight: 400 }}>Select All</div>
      </div>
      <div className={styles.productContainer}>
        {catalog?.products?.map((product) => (
          <div style={{ display: "flex", flexDirection: "row", gap: 6 }}>
            <input
              type="checkbox"
              style={{ alignSelf: "flex-start", marginRight: 8 }}
              checked={selectedProducts.includes(product._id)}
              onChange={() => handleProductSelection(product._id)}
            />
            <ProductCard
              key={product._id}
              product={product}
              handleRemoveBg={handleRemoveBg}
              isRemovingBg={removeBgLoading.ids.includes(product._id)}
              onClick={() =>
                navigate(`/catalogs/${id}/products/${product._id}`)
              }
            />
          </div>
        ))}
      </div>
      <>
        <DeleteConfirmation
          show={showDeleteConfirmation}
          handleCancel={handleCancelDeleteConfirmation}
          handleConfirm={handleConfirmDeleteConfirmation}
        />
        <SetAvailableConfirmation
          show={showSetAvailableConfirmation}
          handleCancel={handleCancelSetAvailableConfirmation}
          handleConfirm={handleConfirmSetAvailableConfirmation}
          productCount={selectedProducts.length}
        />
        <EditCatalog
          show={showEditCatalogDialog}
          handleCancel={handleCancelEditCatalogDialog}
          handleConfirm={handleConfirmEditCatalogDialog}
          initialData={catalog}
        />
      </>
    </div>
  );
};

const ProductCard = ({ product, handleRemoveBg, isRemovingBg, onClick }) => {
  return (
    <div className={styles.productCard} onClick={onClick}>
      <div
        className={styles.productImage}
        style={{ backgroundImage: `url(${product?.image?.[0]})` }}
      >
        <button
          className={styles.removeBgButton}
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveBg(product._id, 0);
          }}
        >
          <MdOutlineAutoFixHigh />
          {isRemovingBg ? <SpinnerComponent /> : "Remove Background"}
        </button>
      </div>
      <div className={styles.textContainer}>
        <div className={styles.leftSection}>
          <h2 className={styles.productName}>{product?.name}</h2>
          <p className={styles.productPrice}>₹{product?.price?.[0]?.cost}</p>
          <div className={styles.descriptionSection}>
            <h3 className={styles.descriptionLabel}>Description</h3>
            <p className={styles.descriptionText}>{product?.description}</p>
          </div>
          {product?.variants?.length > 0 && (
            <p
              style={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#343434a3",
                fontStyle: "italic",
              }}
            >
              + {product?.variants?.length} Variants
            </p>
          )}
        </div>
        <div className={styles.rightSection}>
          <h3 className={styles.additionalDetailsLabel}>Additional Details</h3>
          <div className={styles.detailsList}>
            {product?.item_Details?.map((item, index) => {
              const [label, value] = item.split(":");
              return (
                <div key={index} className={styles.detailItem}>
                  <span className={styles.detailLabel}>{label}</span>
                  <span className={styles.detailValue}>{value?.trim()}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const SpinnerComponent = () => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.spinner}></div>
    </div>
  );
};
